import React from 'react'

const RotateRight = ({ svgProps = {}, pathProps = {} }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="20"
    height="20"
    viewBox="0 0 512 512"
    style={{ enableBackground: 'new 0 0 512 512' }}
    xmlSpace="preserve"
    {...svgProps}
  >
    <g>
      <path
        {...pathProps}
        d="M512,192H320l71.766-71.765C355.5,83.972,307.285,64,256,64s-99.5,19.972-135.765,56.235C83.972,156.5,64,204.715,64,256
        s19.972,99.5,56.235,135.766C156.5,428.028,204.715,448,256,448s99.5-19.972,135.764-56.236c3.029-3.027,5.932-6.146,8.729-9.334
        l48.16,42.143C401.729,478.154,332.82,512,256,512C114.615,512,0,397.385,0,256S114.615,0,256,0
        c70.693,0,134.684,28.663,181.008,74.992L512,0V192z"
      />
    </g>
  </svg>
)

RotateRight.displayName = 'RotateRight'

export default RotateRight
